import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check-in",
  "use": "check-in-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"check-in\"><path fill-rule=\"evenodd\" d=\"M1.51 1.51a1.5 1.5 0 0 1 2.122 0L16.5 14.38V8a1.5 1.5 0 0 1 3 0v11.5H8a1.5 1.5 0 0 1 0-3h6.379L1.51 3.632a1.5 1.5 0 0 1 0-2.121\" clip-rule=\"evenodd\" /><path d=\"m3 11.364-3-3V28a4 4 0 0 0 4 4h24a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4H8.364l3 3H28a1 1 0 0 1 1 1v24a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol